import { render, staticRenderFns } from "./top-notice.vue?vue&type=template&id=6bd9d936&scoped=true&"
import script from "./top-notice.vue?vue&type=script&lang=js&"
export * from "./top-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9d936",
  null
  
)

export default component.exports